import React from 'react';
import proptypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { useRecsCarouselPodTelemetry, useNodeRef } from '../hooks';

const { string: stringType } = proptypes;

const SummaryButton = ({ itemId, storeId, parent, telemetryKey, url }) => {
  const [productPodNodeRef, productPodNode] = useNodeRef();

  const { handleClick } = useRecsCarouselPodTelemetry({
    productPodNode,
    parent,
    title: telemetryKey,
    itemId,
    storeId,
    position: 1,
    url,
    noMountKpi: true,
    noRightClickTracker: true
  });

  return (
    <div ref={productPodNodeRef}>
      <Button
        variant="secondary"
        onClick={handleClick}
        fullWidth
      >
        View Product Details
      </Button>
    </div>
  );
};

SummaryButton.propTypes = {
  itemId: stringType.isRequired,
  storeId: stringType.isRequired,
  parent: stringType.isRequired,
  telemetryKey: stringType.isRequired,
  url: stringType.isRequired
};

SummaryButton.displayName = 'SummaryButton';

export { SummaryButton };